import { types } from "../types/types";

export const authReducer = (state = {}, action ) => {
    
    switch (action.type) {
        case types.login:
            return {
                ...action.payload,
                logged:true,
                comprobation: true
            }
        case types.logout:
            return {
                logged: false,
                comprobation: true
            }
        default:
            return state;
    }
}